import { Routes } from '@angular/router';
import { LayoutPage } from './layout/layout.page';
import { AuthGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/no-auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: '',
    component: LayoutPage,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'menu',
        loadComponent: () =>
          import('./components/menu/menu.component').then((m) => m.MenuComponent),
      },
      {
        path: 'cncs/application/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/cncs-wizard/cncs-wizard/cncs-wizard.component').then(
            (m) => m.CncsWizardComponent
          ),
      },
      {
        path: 'ssdg/application/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/ssdg-wizard/ssdg-wizard.component').then(
            (m) => m.SsdgWizardComponent
          ),
      },
      {
        path: 'msdg/application/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/msdg-wizard/msdg-wizard.component').then(
            (m) => m.MsdgWizardComponent
          ),
      },
      {
        path: 'agrivoltaic-one/application/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/agrivoltaic-one-wizard/agrivoltaic-one-wizard.component').then(
            (m) => m.AgrivoltaicOneWizardComponent
          ),
      },
      {
        path: 'agrivoltaic-two/application/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/agrivoltaic-two-wizard/agrivoltaic-two-wizard.component').then(
            (m) => m.AgrivoltaicTwoWizardComponent
          ),
      },
      {
        path: 'cncs-wizard/:applicationId',
        loadComponent: () =>
          import('./pages/wizards/cncs-wizard/cncs-wizard/cncs-wizard.component').then(
            (m) => m.CncsWizardComponent
          ),
      },
      {
        path: 'application/:applicationId',
        redirectTo: 'cncs/application/:applicationId',
        pathMatch: 'full',
      },
      {
        path: 'simulation/:id',
        loadComponent: () =>
          import('./pages/simulation/simulation-wizard.component').then(
            (m) => m.SimulationWizardComponent
          ),
      },
      {
        path: 'forbidden',
        loadComponent: () =>
          import('./pages/forbidden/forbidden.page').then((m) => m.ForbiddenPage),
      },
      {
        path: 'not-found',
        loadComponent: () =>
          import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/not-found/not-found.page').then((m) => m.NotFoundPage),
      },
    ],
  },
];
